import Vue from 'vue';
import Router from 'vue-router';

import Map from '@/components/Modules/Map/Map';
import ItemDetail from '@/components/Pages/Index/ItemDetail';
import JobDetail from '@/components/Pages/Index/JobDetail';
import Test from '@/components/Pages/Test/Test';

import Styles from '@/components/Pages/Styles/Index';
import ErrorPages from '@/components/Pages/Error/Index';

import Login from '@/components/Pages/Login/Login';
import Users from '@/components/Pages/Users/Index';
import Settings from '@/components/Pages/Settings/Index';
import EmailResetPwd from '@/components/Pages/Login/EmailResetPwd';
import ResetPwd from '@/components/Pages/Login/ResetPwd';

import Form from '@/components/Pages/Form/Form';

import Download from '@/components/Pages/Download.vue';

Vue.use(Router);

export const useroutes = {
  routes: [
    {
      path: '/',
      name: 'Map',
      component: Map,
      meta: {label: 'Map', breadcrumb: 'Map'}
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {label: 'Login'}
    },
    {
      path: '/email_reset_pwd',
      name: 'EmailResetPwd',
      component: EmailResetPwd,
      meta: {label: 'Forgot Password'}
    },
    {
      path: '/password/reset/confirm/:uid/:token',
      name: 'ResetPwd',
      component: ResetPwd,
      meta: {label: 'ResetPwd'}
    },
    {
      path: '/empresa/:document/:edit?',
      name: 'Form',
      component: Form,
      meta: {breadcrumb: 'Form'}
    },
    {
      path: '/items/:id',
      name: 'ItemDetail',
      component: ItemDetail,
      meta: {breadcrumb: 'Item'}
    },
    {
      path: '/jobs/:id',
      name: 'JobDetail',
      component: JobDetail,
      meta: {breadcrumb: 'Job'}
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: {label: 'Users'}
    },
    {
      path: '/test',
      name: 'Test',
      component: Test,
      meta: {label: 'Test'}
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {label: 'Settings'}
    },
    {
      path: '/error/:code',
      name: 'ErrorPages',
      component: ErrorPages,
      meta: {label: 'ErrorPages'}
    },
    {
      path: '/Styles',
      name: 'Styles',
      component: Styles,
      meta: {label: 'Styles'}
    },
    {
      path: '/download',
      name: 'Download',
      component: Download,
      props: (route) => ({ query: route.query.q }),
      meta: {label: 'Download'}
    }
  ]
};

export const userRouter = new Router(useroutes);



// WEBPACK FOOTER //
// ./src/router/user/index.js